import React from "react";
import { Alert } from "@sumprio/ui";
import { Z_INDEX_APP_NOTIFICATIONS_LAYER } from "constants/alert.constants";

export interface PageAlertItem {
  key: string;
  status: "success" | "danger" | "warning" | "info";
  title: string;
  description?: string;
  showDescription?: boolean;
  showAction?: boolean;
  showCloseIcon?: boolean;
  onDismiss?: () => void;
}

export interface PageAlertsProps {
  alerts: PageAlertItem[];
}

export default function PageAlerts({ alerts }: PageAlertsProps) {
  if (alerts.length === 0) return null;

  return (
    <div
      className="page-alerts-root"
      style={{
        position: "fixed",
        inset: 0,
        pointerEvents: "none",
        zIndex: Z_INDEX_APP_NOTIFICATIONS_LAYER,
      }}
    >
      {alerts.map((a) => (
        <Alert
          key={a.key}
          position="top-right"
          status={a.status}
          title={a.title}
          description={a.description}
          showDescription={a.showDescription ?? !!a.description}
          {...(a.showAction !== undefined ? { showAction: a.showAction } : {})}
          showCloseIcon={a.showCloseIcon ?? true}
          {...(a.onDismiss !== undefined ? { onDismiss: a.onDismiss } : {})}
        />
      ))}
    </div>
  );
}
